/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMetadata} from "./EntryMetadata";

export class AwardType extends EntryMetadata {
  constructor(id: string, name: string, public shortName: string, description: string, public isProgramOnly: boolean = false) {
    super(id, name, description);
  }

  static listFromSnapshot(key: string, val: [{name, shortName, description, isProgramOnly}]) {
    let items: Array<AwardType> = [];

    for (let id of Object.keys(val)) {
      items.push(new AwardType(id, val[id].name, val[id].shortName || val[id].name, val[id].description, val[id].isProgramOnly));
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/AwardType.ts